import * as React from "react";
import styles from "./Layout.module.scss";
import Link from "@mui/material/Link";
import logo from "assets/ctrg-limited-logo-transparent.png";
import ctrgBG from "assets/ctrg-limited-auth-page.jpg";
import { Head } from "components/Head";

type LayoutProps = {
  children: React.ReactNode;
  title: string;
};

export const Layout = ({ children, title }: LayoutProps) => {
  return (
    <>
      <Head title={title} />
      <div className="layout-container flex flex-col items-center h-screen ">
        <div className={styles.authCoverWrapper}>
          <img
            className={styles.authCover}
            src={ctrgBG}
            alt="background"
          />
        </div>
        <Link className={styles.logoContainer} href="/">
          <img
            className={`${styles.logo} w-5/6 md:w-2/6 h-full`}
            src={logo}
            alt="CTRG-Limited-Logo"
          />
        </Link>
        <div className="layout-wrapper w-full md:w-[500px] mt-8 md:mt-16 flex flex-col gap-8 p-4">
          <div
            className={`${styles.componentContainer} flex flex-col gap-4 p-4`}
          >
            <h1 className={styles.layoutTitle}>{title}</h1>
            {children}
          </div>
        </div>
        <div className={styles.version}>Version No: 1.65-beta</div>
      </div>
    </>
  );
};
